module.exports = __webpack_public_path__ + "static/media/TableBlack.30f7f873.svg";